import React from "react";
import AlurUKTimg from "../../dist/img/alur-ukt.png";

class AlurUKT extends React.Component {
  render() {
    return (
      <div>
        <img src={AlurUKTimg} width="100%" alt="Alur UKT" />
      </div>
    );
  }
}
export default AlurUKT;
